import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';


// Responde ao callback da Meta no processo de Autenticação

const MetaCallback = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    const processAuth = async () => {
      if (error) {
        const result = {
          type: 'META_AUTH_RESULT',
          success: false,
          error: error,
          error_description: errorDescription
        };
        
        setStatus('error');
        setMessage(`Erro na autorização: ${errorDescription || error}`);
        
        if (window.opener) {
          window.opener.postMessage(result, window.location.origin);
          setTimeout(() => window.close(), 2000);
        }
        return;
      }

      if (code && state) {
        try {
          setMessage('✅ Autorização bem-sucedida!');
          setStatus('success');

          const result = {
            type: 'META_AUTH_RESULT',
            success: true,
            code: code,
            state: state
          };

          // Enviar resultado para janela pai (sem subscription automática)
          if (window.opener) {
            window.opener.postMessage(result, window.location.origin);
            setTimeout(() => window.close(), 1500);
          } else {
            // Fallback: salvar no sessionStorage
            sessionStorage.setItem('meta_auth_code', code);
            sessionStorage.setItem('meta_auth_state', state);
            
            setTimeout(() => {
              window.location.href = '/crm?meta_auth=success'; // Redireciona para CRM
            }, 1500);
          }

        } catch (err) {
          setStatus('error');
          setMessage(`Erro: ${err.message}`);
        }
      }
    };

    processAuth();
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        bgcolor: '#f0f2f5'
      }}
    >
      <CircularProgress size={40} sx={{ color: '#1877F2' }} />
      <Typography variant="h6" sx={{ mt: 2, color: '#1877F2' }}>
        Processando autorização Meta...
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
        Esta janela será fechada automaticamente.
      </Typography>
      {status === 'error' && (
        <Typography variant="body2" sx={{ mt: 1, color: 'red' }}>
          {message}
        </Typography>
      )}
      {status === 'success' && (
        <Typography variant="body2" sx={{ mt: 1, color: 'green' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default MetaCallback;